/**
* In Add Parent function is used to add or create new parent details and it's functions declare this file
**/
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { validate } from '../../../services/ValidationService';
import ApiService from '../../../services/ApiService';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ImageCroper from '../../../shared/modals/ImageCroper'
import { dataURItoBlob, filterGeoLocation, convertS3privateToPublic, goBack, convertTimeFormat,flatPickerFormatDate } from '../../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import constantVariables from '../../../dataset/constantVariables.json';
import Select from 'react-select';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

function EditParent() {
	//Intial state declaration
	const { id } = useParams();
	const [data, setData] = useState({});
	const [error, setError] = useState({});
	const [isValid, setValid] = useState(true);
	const navigate = useNavigate();
	const [show, SetShow] = useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const [tab, setTab] = useState(0);
	const [physicianInfo, setPhysicianInfo] = useState([]);
	const [childInfo, setChildInfo] = useState([]);
	const [errorChild, setChildError] = useState({});
	const [workSchedules, setWorkSchedules] = useState([]);
	const [filteredSchedules, setFilteredSchedules] = useState([]);
	let childErr = false;
	const dobflatpickrRef = useRef([]); // Create a ref for Flatpickr
	const eddflatpickrRef = useRef([]); // Create a ref for Flatpickr
	//validate patterns
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const { t } = useTranslation();

	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
			fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	};
	const imageData = (data) => setCropImage(data)

	/** 
	* Validation schema for Parent Fields
	* @first_name - required field and pass the parent first_name
	* @last_name - required field and pass the parent last_name
	* @members - required field and pass the parent members
	* @email - required field and should be in correct parent email format 
	* @mobileNumber - required field and pass the parent mobileNumber
	* @city - required field and pass the parent city 
	* @state - required field and pass the parent state 
	* @gender - required field and pass the parent gender 
	* @zipcode - required field and pass the parent zipcode 
	**/
	const fields = [
		{ name: 'child_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'child_dob', validation: Yup.string().required(t('error.required')) },
		{ name: 'child_isPremature', validation: Yup.boolean().required(t('error.required')) },
		// { name: 'child_expected_dob', validation: Yup.string() },
		{
			name: 'child_expected_dob',
			validation:
				data.child_isPremature === 'true'
				? Yup.string()
				.required(t('error.required'))
			: Yup.string(),
		},
		{
			name: 'child_premeture_week',
			validation:
				// data.child_isPremature === 'true'
				// 	? Yup.string()
				// 		.test('Invalid number', constantVariables.error.numberOnly, (value) => {
				// 			return /^\d+$/.test(value);
				// 		})
				// 		.required(constantVariables.error.required)
				Yup.string(),
		},
		{ name: 'child_gender', validation: Yup.string().required(t('error.required')) },
		{
			name: 'child_blood_group',validation: Yup.string()
		},
		{ name: 'child_notes', validation: Yup.string().trim() },
		{ name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
		{
			name: 'members',
			validation: Yup.string()
				.matches(/^\d+$/, t('error.numberFormat'))
				.required(t('error.required'))
		},
		{ name: 'email', validation: Yup.string().test('Invalid email address', t('error.email'), (value) => { return emailPattern.test(value); }).required(t('error.email')) },
		{ name: 'mobileNumber', validation: Yup.string() },
		{ name: 'city', validation: Yup.string() },
		{ name: 'gender', validation: Yup.string() },
		{ name: 'state', validation: Yup.string() },
		{
			name: 'zipcode',
			validation: Yup.string()
				.nullable() // Allows the field to be nullable
				.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number
				// .test('len', constantVariables.error.zipcode, function (value) {
				// 	return !value || value.length >= 5; // Only check length if value is not empty
				// })
		},

	];

	useEffect(() => {
		(async () => {
			if (id) {
				try {
					const response = await ApiService.getParentDetails(id); // Assuming the API uses the ID from the URL

					if (response.status === 200 && response.data) {
						const { parentInfo, memberInfo, physicianProfiles, workSchedules, physicianMapped } = response.data;
						if(memberInfo.length > 0){
							await setChildInfo(memberInfo);
						}else{
							await setChildInfo(state => [...state, { 
								name: '', 
								dob: '', 
								expected_dob: '', 
								premature_weeks: null, 
								blood_group:'', 
								notes:'' 
							  }]);
						}
						// Populate parent details into the form
						setData({
							/* child_id: memberInfo[0].id,
							child_name: memberInfo[0].name || '',
							child_dob: memberInfo[0].dob || '',
							child_expected_dob: memberInfo[0].delivery_date || '',
							child_premeture_week: memberInfo[0].premature_weeks || '',
							child_isPremature: memberInfo[0].gender === true ? "true" : "false",
							child_gender: memberInfo[0].gender === 0 ? "0" : "1",
							child_blood_group: memberInfo[0].blood_group || '',
							child_notes: memberInfo[0].description || '', */
							first_name: parentInfo.first_name || '',
							last_name: parentInfo.last_name || '',
							countryNameCode: parentInfo.countryNameCode || '',
							countryCode: `${parentInfo.countryCode}` || '',
							email: parentInfo.email || '',
							gender: parentInfo.gender !== null && parentInfo.gender !== undefined ? parentInfo.gender.toString() : '',
							mobileNumberWithCode: `${parentInfo.countryCode} ${parentInfo.mobileNumber}` || '',
							mobileNumber: `${parentInfo.mobileNumber}` || '',
							address_one: parentInfo.address_one || '',
							address_two: parentInfo.address_two || '',
							members: parentInfo.members || '',
							city: parentInfo.city || '',
							state: parentInfo.state || '',
							physicianId: physicianMapped || '',
							photo: parentInfo.photo
						});
						console.log("data ",data);
						// Check and set zipcode if not null
						if (parentInfo.zipcode !== null) {
							setData(prevData => ({
								...prevData,
								zipcode: parentInfo.zipcode
							}));
						}
						// Set physicians and work schedules
						setPhysicianInfo(physicianProfiles || []);
						setWorkSchedules(workSchedules || []);
						const filtered = workSchedules.filter(schedule => schedule.physician === physicianMapped);
						setFilteredSchedules(filtered);
						console.log("filter ",filteredSchedules);
					}
				} catch (error) {
					console.error("Error fetching parent details:", error);
				}
			}
		})();
	}, [id]);

	/** 
	* To handle input change event 
	* @e - we get the event details from the Change action
	**/
	const handleChange = async (e) => {
		const { name, value } = e.target;

		// Get today's date in the YYYY-MM-DD format
		//const today = new Date().toISOString().split("T")[0];

		// Update the state with the input value
		setData({ ...data, [name]: value });

		// Validate the input and update the error state
		const Errors = await validate({ [name]: value }, fields);
		setError({ ...error, [name]: Errors[name] });

		// Additional logic for physicianId to filter workSchedules based on the selected physician
		if (name === 'physicianId') {
			const filtered = workSchedules.filter(schedule => schedule.physician === value);
			setFilteredSchedules(filtered);
		}
	};


	/** 
	 * To handle submit event 
	 * @e - we get the event details from the form submit action
	 **/
	const handleSubmit = async (e) => {
		const hospitalId = localStorage.getItem("userId");
		e.preventDefault();
		const Errors = {};/* await validate(data, fields);
		setError(Errors); */
		await validateChildInfo();
		const requiredFieldsForTab0 = ['child_name', 'child_dob', 'child_isPremature', 'child_expected_dob', 'child_premeture_week', 'child_gender', 'child_blood_group', 'child_notes']; // List of fields that need to trigger setTab(0) if they have errors
		const otherFields = Object.keys(Errors).filter(field => !requiredFieldsForTab0.includes(field));
		if (otherFields.length > 0) { // If there are errors in other fields, move to setTab(1)
			setTab(1);
		}
		// Proceed if there are no validation errors and valid is true
		if (!Object.keys(Errors).length && isValid && childErr) {
			try {
				var fileResponse;
				var response;
				if (cropImge !== undefined) {
					const formData = new FormData();
					const fileConvertData = await dataURItoBlob(cropImge);
					formData.append('file', fileConvertData);
					fileResponse = await ApiService.uploadNewPhoto(response?.data?.orgId, formData);
				}
				
				 // Remove `premature_weeks` if it is null or empty in each child record
				const filteredChildInfo = { ...childInfo };

				Object.keys(filteredChildInfo).forEach((key) => {
					const child = filteredChildInfo[key];

					// Remove `premature_weeks` if it's null or empty
					if (!child.premature_weeks) {
						delete child.premature_weeks;
					}
				
					// Set `delivery_date` to null if `isPremature` is false
					if (child.isPremature === false || child.isPremature === "false") {
						child.delivery_date = null;
					}
				});

				// Convert filteredChildInfo to an array
				const memberInfoArray = Object.values(filteredChildInfo);

				 console.log("Filtered Data : ",filteredChildInfo);

				const payload = { // Prepare the payload in the expected format
					parentInfo: {
						account: id,
						first_name: data.first_name || '',
						last_name: data.last_name || '',
						email: data.email || '',
						mobileNumber: data.mobileNumber || '',
						members: data.members || 1,
						address_one: data.address_one || '',
						address_two: data.address_two || '',
						city: data.city || '',
						state: data.state || '',
						countryCode: data.countryCode || '',
						countryNameCode: data.countryNameCode || '',
						zipcode: data.zipcode || null,
						photo: fileResponse?.data?.filesName,
						gender: data.gender === "" ? null : data.gender,
					},
					memberInfo: memberInfoArray,
					physicianInfo: [
						{
							hospitalAdmin: hospitalId,
							physician: data.physicianId || '', // Physician ID from form
						}
					],
					updated_by: hospitalId
				};
				// Call the API to create a parent
				response = await ApiService.updateParentAndUpdateMember(payload);
				// If the response is successful
				if (response.status === 200) {
					toast.success(response?.data?.message);
					navigate('/hospital/admin/parents');
				} else {
					// Handle any errors from the API
					toast.error(response?.data?.message || 'Something went wrong');
				}
			} catch (error) {
				// Handle any unexpected errors
				console.error(error);
				toast.error('An error occurred. Please try again.');
			}
		}
	};

	/** 
	* To check phone number valid or not 
	* @value - we pass the actual phone number
	* @country - we pass the countryCode
	* @e - we get the event details from the onChange action
	* @formattedValue - we pass the country formatted Value
	**/
	const handlePhone = async (value, country, e, formattedValue) => {
		const { dialCode } = country;

		// Update both fields to store full and partial phone numbers
		setData({
			...data,
			mobileNumberWithCode: formattedValue, // Store full formatted value with country code
			mobileNumber: formattedValue.split("+" + dialCode + " ")[1], // Store only the number part
			countryCode: '+' + dialCode,
			countryNameCode: country?.countryCode,
		});

		// Validate the full phone number with the country code
		const Errors = await validate({ mobileNumberWithCode: formattedValue }, fields);
		setError({ ...error, mobileNumberWithCode: Errors.mobileNumberWithCode });

		// Check if the input matches a valid phone number format
		if (!formattedValue || (country.format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
			setValid(true);
		} else {
			setValid(false);
		}
	};

	/** 
	* To change city input 
	* @e - we get the event details form the change action
	**/
	const changeCity = async (e) => {
		const { value } = e.target;
		var obj = {};
		if (value.trim().length === 0) {
			obj = { city: '', state: '' };
		} else {
			obj = { city: value };
		}
		setData((data) => ({ ...data, ...obj }));
		const Errors = await validate({ city: value }, fields);
		setError({ ...error, city: Errors['city'] });
	}

	/** 
	* To select city input 
	* @e - we get the event details from the Select action
	**/
	const selectCity = async (e) => {
		var location = await filterGeoLocation(e);
		await setData((data) => ({ ...data, ...location }));
	}

	// Validate childInfo errors
	const validateChildInfo = async () => {
		let Errors = {};
		let allErrors = {};
		for (let i = 0; i < childInfo.length; i++) { // First, validate for all children in childInfo
			const childInfoIndex = childInfo[i];
			const errorPayload = Object.fromEntries(
				Object.entries({
					child_blood_group: childInfoIndex.blood_group,
					child_expected_dob: childInfoIndex.delivery_date,
					child_name: childInfoIndex.name,
					child_dob: childInfoIndex.dob,
					// child_premeture_week: childInfoIndex.premature_weeks,
					child_isPremature: childInfoIndex.isPremature,
					child_gender: childInfoIndex.gender,
					child_notes: childInfoIndex.description,
				}).filter(([_, value]) => value !== null) // Filter out null values
			);
			const childFields = fields.filter(field => field.name.startsWith('child_')); // Filter childFields as before
			const childErrors = await validate(errorPayload, childFields); // Validate each childInfo object
			// if (childInfoIndex.isPremature) { // Add custom validation for child_premeture_week
			// 	if (childInfoIndex.premature_weeks === null || childInfoIndex.premature_weeks === undefined) {
			// 	childErrors.child_premeture_week = constantVariables.error.required;
			// 	} else if (typeof childInfoIndex.premature_weeks !== 'number') {
			// 	childErrors.child_premeture_week = constantVariables.error.numberOnly;
			// 	}
			// }
			if (childInfoIndex.isPremature) { // Add custom validation for child_premeture_week
				if (!childInfoIndex.delivery_date) {
					childErrors.child_expected_dob = t('error.required');
				}
			}
			allErrors[i] = childErrors; // Store errors for each child
		}
		await setChildError(prevError => ({ ...prevError, ...allErrors })); // Set the errors for all children at once
	
		if (!Object.keys(allErrors).some(index => Object.keys(allErrors[index]).length)) {
			Errors = {};
			childErr = true;
		} else {
			const errorIndices = Object.keys(allErrors).filter(index => Object.keys(allErrors[index]).length);
			errorIndices.forEach(index => {
				const errorField = Object.keys(allErrors[index])[0];
				Errors = { ...Errors, [errorField]: allErrors[index][errorField] };
			});
			setChildError(prevError => ({ ...prevError, ...Errors }));
			childErr = false;
		}
		
		if (!Object.keys(Errors).length) { // Check if all Errors are empty, then proceed
			setTab(2);
		} else {
			setTab(1);
		}
	}

	/** To go to next page 
	* @tab - pass the selected tab value 
	* @e - we get the event details from the click action
	**/
	const goNext = (tab) => async (e) => {
		e.preventDefault();
		if (tab === 0) {
			const selectedFields = fields.filter(field =>
				['first_name', 'last_name', 'members', 'email'].includes(field.name)
			); // Filter out fields to only include 'first_name', 'last_name', 'members', and 'email'
			const Errors = await validate(data, selectedFields); // Validate only the selected fields
			setError(Errors);
			if (!Object.keys(Errors).length && isValid) { // Proceed to the next tab if there are no errors and isValid is true
				setTab(1);
			}
		} else if (tab === 1){
			validateChildInfo();
		}
	};

	/** 
	* To handle the image change
	* @e - we get the event details from the input file select action
	**/
	const handleFile = async (e) => {
		e.preventDefault();
		const file = e.target.files[0];
		openCropModal(file);

	}

	/** 
	* To open the image crop modal
	* @file - we pass the image details in the base 64 bit format
	**/
	const openCropModal = async (file) => {

		if (file) {
			let ext = file.name.split('.').pop();
			let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
			if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await SetShow(false);
				return;
			}
			if (file.size > 100 * 1024 * 1024) {
				toast.error(t('error.fileSize'));
				await SetShow(false);
				return;
			}
			const reader = new FileReader();
			reader.onload = () => { setImage(reader.result) };
			reader.readAsDataURL(file);
			await SetShow(true);
		} else {
			await SetShow(false);
		}
	}

	/** 
	* To handle event drag
	* @e - we get the event details from the drag over action
	**/
	const handleDrag = (e) => {
		e.preventDefault();
	}

	/** 
	* To handle event drop
	* @e - we get the event details from the drop over action
	**/
	const handleDrop = (e) => {
		e.preventDefault();
		const { files } = e.dataTransfer;
		openCropModal(files[0]);
	}

	/** 
	* To remove childInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const removeChildInfo = (index) => {
		setChildInfo(prevChildInfo => prevChildInfo.filter((_, i) => i !== index));
	};	

	/** 
	* To add childInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const addChildInfo = (index) => async (e) => {
		e.preventDefault();
		const childInfoIndex = childInfo[index];
		const errorPayload = Object.fromEntries(
			Object.entries({
				child_blood_group: childInfoIndex.blood_group,
				child_expected_dob: childInfoIndex.delivery_date,
				child_name: childInfoIndex.name,
				child_dob: childInfoIndex.dob,
				child_premature_week: childInfoIndex.premature_weeks,
				child_isPremature: childInfoIndex.isPremature,
				child_gender: childInfoIndex.gender,
				child_notes: childInfoIndex.description,
			}).filter(([_, value]) => value !== null) // Filter out null values
		);
		const childFields = fields.filter(field => field.name.startsWith('child_')); // Filter childFields as before
		const Errors = await validate(errorPayload, childFields); // Validate using the new errorPayload object
		// if (childInfoIndex.isPremature) { // Add custom validation for child_premeture_week
		// 		if (childInfoIndex.premature_weeks === null || childInfoIndex.premature_weeks === undefined) {
		// 		Errors.child_premeture_week = constantVariables.error.required;
		// 		} else if (typeof childInfoIndex.premature_weeks !== 'number') {
		// 		Errors.child_premeture_week = constantVariables.error.numberOnly;
		// 		}
		// }
		if (childInfoIndex.isPremature) { // Add custom validation for child_premeture_week
			if (childInfoIndex.delivery_date === null || childInfoIndex.delivery_date === "") {
			Errors.child_expected_dob = t('error.required');
			}
		}

		await setChildError(prevError => ({ ...prevError, [index]: Errors }));
		if (Object.values(Errors).length === 0) {
		  await setChildInfo(state => [...state, { 
			name: '', 
			dob: '', 
			expected_dob: '', 
			premature_weeks: null, 
			blood_group:'', 
			notes:'' 
		  }]);
		}
	  };
	  
	  
	/** 
	* To handle the childInfo change
	* @index - we pass the index value of the UI select
	* @e - we get the event details form the change action
	**/
	const changeChildInfo = (index) => async (e) => {
		const { name, value } = e.target;
		console.log(`Input Changed: name = ${name}, value = ${value}`);
	
		const propertyName = name.replace(/child_|_\d+$/g, ''); // Remove 'child_' prefix and index suffix to get the property name
		console.log(`Property Name Derived: ${propertyName}`);
	
		let updatedValue; // Determine the correct updated value based on the property name
		switch (propertyName) {
			case 'isPremature':
				updatedValue = value === 'true'; // Convert to boolean
				break;
			case 'expected_dob':
				updatedValue = flatPickerFormatDate(value) ; // Keep as string
				break;
			case 'premeture_week':
				updatedValue = Number(value) || null; // Convert to number, default to 0 if NaN
				break;
			case 'gender':
				updatedValue = Number(value); // Convert to number
				break;
			case 'notes':
				updatedValue = value; // Keep as string
				break;
			case 'dob':
				updatedValue = flatPickerFormatDate(value) ; // Keep as string
				break;
			default:
				updatedValue = value; // Default case, keep as string
				break;
		}
		console.log(`Updated Value for ${propertyName}:`, updatedValue);
	
		const updateArr = childInfo.map((item, i) => {
			if (index === i) {
				const updatedItem = { ...item };
	
				if (propertyName === 'expected_dob') {
					updatedItem.delivery_date = updatedValue;
	
					// New logic: Calculate premature_weeks
					const dob = updatedItem.dob;
					const deliveryDate = updatedValue;
					console.log(`DOB: ${dob}, Delivery Date: ${deliveryDate}`);
	
					if (dob && deliveryDate) {
						const dobDate = new Date(dob);
						const deliveryDateObj = new Date(deliveryDate);

						// Calculate the difference in days and convert to weeks
						const diffTime = Math.abs(deliveryDateObj - dobDate);
						const actualWeeks = Math.floor(diffTime / (7 * 24 * 60 * 60 * 1000)); // Weeks between dates
						
						// Subtract from 40 weeks to get premature weeks
						const prematureWeeks = Math.max(40 - actualWeeks, 0); // Ensure no negative values
	
						// const differenceInDays = Math.floor(
						// 	(deliveryDateObj - dobDate) / (1000 * 60 * 60 * 24)
						// );
	
						// console.log(`Difference in Days: ${differenceInDays}`);
	
						// if (differenceInDays > 0) {
						// 	const weeksDifference = Math.floor(differenceInDays / 7);
						// 	const prematureWeeks = 40 - weeksDifference;
	
						updatedItem.premature_weeks =  prematureWeeks.toString(); // Prevent negative weeks
						// 	console.log(`Weeks Difference: ${weeksDifference}, Premature Weeks: ${updatedItem.premature_weeks}`);
						// }
					}
				} else if (propertyName === 'premeture_week') {
					updatedItem.premature_weeks = updatedValue;
				} else if (propertyName === 'gender') {
					updatedItem.gender = updatedValue;
				} else if (propertyName === 'dob') {
					updatedItem.dob = updatedValue;
					updatedItem.premature_weeks = ""; // Reset premature_weeks
                	updatedItem.delivery_date = ""; // Reset delivery_date
				}else if (propertyName === 'notes') {
					updatedItem.description = updatedValue;
				} else {
					updatedItem[propertyName] = updatedValue; // For isPremature or any other
				}
	
				console.log(`Updated Item:`, updatedItem);
				return updatedItem;
			} else {
				return item;
			}
		});
	
		console.log(`Updated Array of Children Info:`, updateArr);
	
		const childFields = fields.filter(field => field.name.startsWith('child_'));
		const baseName = name.split('_').slice(0, -1).join('_'); // Removes the last part after the underscore
		const Errors = await validate({ [baseName]: value }, childFields);
	
		console.log(`Validation Errors for ${baseName}:`, Errors);
	
		setChildError(prevError => {
			const fieldName = name.replace(/_\d+$/, ''); // Get the field name without the index
			if (!prevError[index]) {
				prevError[index] = {};
			}
			console.log(`Previous Errors for index ${index}:`, prevError[index]);
	
			return { ...prevError, [index]: { ...prevError[index], [fieldName]: Errors[fieldName] } };
		});
	
		await setChildInfo(updateArr);
		console.log(`Final Child Info State:`, updateArr);
	};
	

	return (
		<main id="main" className="main">
			{/*import ImageCroper*/}
			<ImageCroper
				show={show}
				handleClose={handleClose}
				image={image}
				cropImge={imageData}
			/>
			{/*Page Title Section*/}
			<div className="pagetitle clearfix">
				<div className="float-start">
					<h1>Edit {t('profile.parentInfo')}</h1>
					<nav>
						<ol className="breadcrumb">
							<li className="breadcrumb-item"><Link to='/hospital/admin/dashboard'>{constantVariables.sidebar.home}</Link></li>
							<li className="breadcrumb-item"><Link to='/hospital/admin/parents'>{constantVariables.sidebar.parent}</Link></li>
							<li className="breadcrumb-item active">Edit {t('profile.parentInfo')}</li>
						</ol>
					</nav>
				</div>
				<div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
				</div>
			</div>
			{/*End Page Title Section*/}
			{/*Page Content Section*/}
			<section>
				<div className="row">
					{/* <!--ProfileImg--> */}
					<div className="col-lg-3">
						<div className="card profile-img">
							<div className="card-body">
								<div className="upload-box d-none d-lg-block">
									<div className="box text-center" onDrop={handleDrop} onDragOver={handleDrag}>
										<input type="file" onChange={handleFile} name="file-6[]" id="file-6" className="inputfile inputfile-4" />
										<label htmlFor="file-6">
											{cropImge && (<img className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
											{(!cropImge && data && data?.photo && data?.photo === 'default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
											{(!cropImge && data && data?.photo && data?.photo !== 'default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
											<span>Edit/Change <br /> (Drag and Drop)</span>
										</label>
									</div>
								</div>
								<div className="text-center text-tmAquaGreen mt-4">
									<h6>{t('profile.uploadPicture')}</h6>
								</div>
							</div>
						</div>
					</div>
					{/* <!--ProfileInfo--> */}
					<div className="col-lg-9">
						<div className={`card form-card profile-info admin-profile-info`}>
							<div className="card-body pt-4">
								<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(0)} className={tab === 0 ? "nav-link active" : "nav-link"} type="button" role="tab">{t('profile.parentInfo')}</span>
									</li>
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(1)} className={tab === 1 ? "nav-link active" : "nav-link"} type="button" role="tab" >{t('profile.childInfo')}</span>
									</li>
									<li className="nav-item" role="presentation">
										<span onClick={() => setTab(2)} className={tab === 2 ? "nav-link active" : "nav-link"} type="button" role="tab">{t('profile.physicianInfo')}</span>
									</li>
								</ul>
								<div className="tab-content">

									{/* <!--TAB-01--> */}
									{tab === 0 && <div>
										<form autoComplete="off">
											<div className="row">
												<div className="col-lg-5 col-md-6">
													<div className=" form-group">
														<label>{t('profile.firstName')} </label>
														<input name="first_name" onChange={handleChange} value={data.first_name ? data.first_name.trim() : ''} type="text" className="form-control" placeholder={t('profile.firstName')} />
														{error && error.first_name && <span className="required">{error.first_name}</span>}
													</div>
												</div>
												<div className="col-lg-5 col-md-6">
													<div className=" form-group">
														<label>{t('profile.lastName')}</label>
														<input name="last_name" onChange={handleChange} value={data.last_name ? data.last_name.trim() : ''} type="text" className="form-control" placeholder={t('profile.lastName')} />
														{error && error.last_name && <span className="required">{error.last_name}</span>}
													</div>
												</div>
												<div className="col-lg-2 col-md-6">
													<div className=" form-group">
														<label>{t('profile.familyMember')}</label>
														<input name="members" maxLength={2} onChange={handleChange} value={data.members ? data.members : ''} type="text" className="form-control" placeholder="Ex. 2" />
														{error && error.members && <span className="required">{error.members}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.phoneNumber')}</label>
														<PhoneInput
															inputProps={{
																name: 'mobileNumber',
																style: { width: '100%' }
															}}
															value={data?.mobileNumberWithCode ? data?.mobileNumberWithCode : ''}
															country={'us'}
															onChange={handlePhone}
														/>
														{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
														{!isValid && !error.mobileNumber && <span className="required">{t('error.validPhoneNumber')}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.emailAddress')}</label>
														<input name="email" onChange={handleChange} value={data.email ? data.email : ''} type="text" className="form-control" placeholder="youremail@mail.com" />
														{error && error.email && <span className="required">{error.email}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.relation')}</label>
														<select name="gender" value={data?.gender ? data.gender : ''} onChange={handleChange} className="form-select">
															<option value='' disabled>{t('common.relation')}</option>
															<option value="0" >{t('profile.father')}</option>
															<option value="1" >{t('profile.mother')}</option>
														</select>
														{error && error.gender && <span className="required">{error.gender}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressOne')}</label>
														<input name="address_one" onChange={handleChange} value={data.address_one ? data.address_one : ''} type="text" className="form-control" placeholder={t('common.addressLine1')} />
														{error && error.address_one && <span className="required">{error.address_one}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressTwo')}</label>
														<input name="address_two" value={data.address_two ? data.address_two : ''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.addressLine2')} />
														{error && error.address_two && <span className="required">{error.address_two}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.city')} </label>

														<Autocomplete
															value={data?.city ? data.city : ''}
															className="form-control"
															placeholder={t('common.city')} 
															onChange={changeCity}
															onPlaceSelected={selectCity}
															types={['(cities)']}
														/>
														{error && error.city && <span className="required">{error.city}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.state')} </label>
														<input name="state" readOnly value={data.state ? data.state : ''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.state')} />
														{error && error.state && !data.state && <span className="required">{error.state}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.zipCode')} </label>
														<input name="zipcode" onChange={handleChange} type="text" value={data.zipcode ? data.zipcode.trim() : ''} className="form-control" placeholder={t('common.zipCode')} />
														{error && error.zipcode && <span className="required">{error.zipcode}</span>}
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">
												<div className="col-lg-12 text-end">
													<button onClick={goNext(0)} type="button" className="btn btn-tmAquaGreen btnNext"><i className="iconly-Light-ArrowRight align-middle"></i> {t('profile.next')}</button>

												</div>
											</div>
										</form>
									</div>}

								    {/* <!--TAB-02--> */}
									{tab === 1 && (
									<div>
										<form autoComplete="off">
										<div className="row">
											<div className="col-lg-12">
											{childInfo && childInfo.map((item, i) => (
												<div key={i} className="row">
												{/* Child Name */}
												<div className="col-lg-6 col-md-12 mb-3">
													<label>{t('profile.childName')}</label>
													<input 
													onChange={changeChildInfo(i)} 
													value={item.name.trim() || ''} 
													name={`child_name_${i}`}
													type="text" 
													className="form-control" 
													placeholder={t('profile.childName')}
													/>
													{errorChild[i] && errorChild[i].child_name && (
													<span className="required">{errorChild[i].child_name}</span>
													)}
												</div>

												{/* Child DOB */}
												<div className="col-lg-6 col-md-12 mb-3 admin-flatpicker">
													<label>{t('profile.childAge')}</label>
													{/* <input 
													type="date" 
													onChange={changeChildInfo(i)} 
													value={item.dob || ''} 
													name={`child_dob_${i}`}
													className="form-control admin-date-input" 
													max={new Date().toISOString().split("T")[0]} 
													/> */}
													<div className="input-group">
														<Flatpickr
														value={item.dob || ''}
														name={`child_dob_${i}`}
														onChange={(selectedDates) => {
															// Call changeChildInfo with the selected date
															changeChildInfo(i)({ target: { name: `child_dob_${i}`, value: selectedDates[0] } });
														}}
														options={{
															dateFormat: "Y-m-d", // Format of the date
															maxDate: "today", // Disallow future dates
														}}
														placeholder={t('profile.selectDate')} // Placeholder text
														className="form-control" // Optional: Add a CSS class
														// ref={flatpickrRef} // Bind Flatpickr to the ref
														ref={(el) => (dobflatpickrRef.current[i] = el)}
														/>														
														<span className="input-group-text input-button" title="toggle" 
														onClick={() => dobflatpickrRef.current[i].flatpickr.open()}>
															<i className="ri-calendar-line"></i>
														</span>
													</div>
													{errorChild[i] && errorChild[i].child_dob && (
													<span className="required">{errorChild[i].child_dob}</span>
													)}
												</div>

												{/* Premature Radio Buttons */}
												<div className="col-lg-6 col-md-12">
												<div className="form-group">
													<label>{t('profile.childPremature')}</label>
													<div className="checkRadio-bg">
													<div className="d-flex">
														<div className="form-check form-check-inline">
														<input 
															onChange={changeChildInfo(i)} 
															checked={item.isPremature === true} 
															className="form-check-input admin-form-check-input" 
															type="radio" 
															name={`child_isPremature_${i}`}  
															value={true} 
														/>
														<label className="form-check-label">Yes</label>
														</div>
														<div className="form-check form-check-inline">
														<input 
															onChange={changeChildInfo(i)} 
															checked={item.isPremature === false} 
															className="form-check-input admin-form-check-input" 
															type="radio" 
															name={`child_isPremature_${i}`}  
															value={false} 
														/>
														<label className="form-check-label">No</label>
														</div>
													</div>
													</div>
													{errorChild[i] && errorChild[i].child_isPremature && (
														<span className="required">{errorChild[i].child_isPremature}</span>
													)}
												</div>
												</div>

												{/* Additional fields if premature */}
												{item.isPremature === true && (
													<>
													<div className="col-lg-6 col-md-12 mb-3 admin-flatpicker">
														<label>{t('profile.delivaryDate')}</label>
														{/* <input 
														type="date" 
														onChange={changeChildInfo(i)} 
														value={item.delivery_date || ''} 
														name={`child_expected_dob_${i}`} 
														className="form-control admin-date-input" 
														min={item.dob ? new Date(new Date(item.dob).setDate(new Date(item.dob).getDate() + 1))
															.toISOString()
															.split("T")[0] : new Date().toISOString().split("T")[0]}  
														/> */}
														<div className="input-group">
															<Flatpickr
															value={item.delivery_date || ''}
															name={`child_expected_dob_${i}`}
															onChange={(selectedDates) => {
																// Call changeChildInfo with the selected date
																changeChildInfo(i)({ target: { name: `child_expected_dob_${i}`, value: selectedDates[0] } });
															}}
															options={{
																dateFormat: "Y-m-d", // Format of the date
																minDate: item.dob
																? new Date(new Date(item.dob).setDate(new Date(item.dob).getDate() + 1))
																.toISOString()
																.split("T")[0]
																: "today", // Set minDate dynamically
															}}
															placeholder={t('profile.selectDate')} // Placeholder text
															className="form-control" // Optional: Add a CSS class
															// ref={flatpickrRef} // Bind Flatpickr to the ref
															ref={(el) => (eddflatpickrRef.current[i] = el)}
															/>														
															<span className="input-group-text input-button" title="toggle" 
															onClick={() => eddflatpickrRef.current[i].flatpickr.open()}>
																<i className="ri-calendar-line"></i>
															</span>
														</div>
														{errorChild[i] && errorChild[i].child_expected_dob && (
														<span className="required">{errorChild[i].child_expected_dob}</span>
														)}
													</div>

													<div className="col-lg-6 col -md-12 mb-3">
														<label>{t('profile.childWeek')}</label>
														<input 
														disabled
														type="text" 
														onChange={changeChildInfo(i)} 
														value={item.premature_weeks === 0 ? "0" : item.premature_weeks ||  ''} 
														name={`child_premeture_week_${i}`} 
														className="form-control" 
														placeholder= {t('profile.childWeek')}
														/>
														{errorChild[i] && errorChild[i].child_premeture_week && (
														<span className="required">{errorChild[i].child_premeture_week}</span>
														)}
													</div>
													</>
												)}

												{/* Child Gender */}
												<div className="col-lg-6 col-md-12 mb-3">
													<label>{t('profile.gender')}</label>
													<select 
													name={`child_gender_${i}`} 
													value={item.gender === '' || item.gender === undefined ? '' : item.gender === 0 ? '0':'1'} 
													onChange={changeChildInfo(i)} 
													className="form-select"
													>
													<option value='' disabled>{t('profile.selectGender')}</option>
													<option value="0">{t('profile.male')}</option>
													<option value="1">{t('profile.female')}</option>
													</select>
													{errorChild[i] && errorChild[i].child_gender && (
													<span className="required">{errorChild[i].child_gender}</span>
													)}
												</div>

												{/* Blood Group */}

												<div className="col-lg-6 col-md-12">
													<div className=" form-group">
														<label>{constantVariables.table.bloodGroup} </label>
														<select name={`child_blood_group_${i}`} className="form-select" value={item.blood_group?item.blood_group:''} onChange={changeChildInfo(i)} >
															<option value='' disabled>{t('profile.selectBloodGroup')}</option>
															<option value="A+">A+</option>
															<option value="A-">A-</option>
															<option value="B+">B+</option>
															<option value="B-">B-</option>
															<option value="O+">O+</option>
															<option value="O-">O-</option>
															<option value="AB+">AB+</option>
															<option value="AB-">AB-</option>
														</select>
														{/* {errorChild[i] && errorChild[i].child_blood_group && (
															<span className="required">{errorChild[i].child_blood_group}</span>
														)} */}
													</div>
												</div>



												{/* Notes */}
												<div className="col-lg-12 col-md-12 mb-3">
													<label>{constantVariables.table.notes}</label>
													<textarea 
													onChange={changeChildInfo(i)} 
													name={`child_notes_${i}`} 
													value={item.description || ''} 
													className="form-control" 
													rows="4"
													></textarea>
												</div>

												{/* Add/Remove buttons */}
												<div className="col-lg-1 d-flex align-items-center">
													{/* Show remove button only if the child object doesn't have an `id` */}
													{(!childInfo[i].id && childInfo.length > 1) && (
														<button 
														onClick={() => removeChildInfo(i)} // Call remove function
														type="button" 
														className="btn btn-outline-danger child-info-btn me-2 mb-2"
														>
														<i className="ri-close-fill me-1"></i>{t('profile.removeChildren')}
														</button>
													)}

													{/* Add button only for the last childInfo item */}
													{childInfo.length - 1 === i && (
													<button 
														onClick={addChildInfo(i)} 
														type="button" 
														className="btn btn-outline-tmAquaDgreen child-info-btn mb-2"
													>
														<i className="ri-add-fill me-1"></i>{t('profile.addChildren')}
													</button>
													)}
												</div>

												{/* HR after each child except the last one */}
												{i < childInfo.length - 1 && <hr style={{ maxWidth: '95%' }}/>}
												</div>
											))}
											</div>
										</div>

										{/* Prev-Next Button Section */}
										<div className="row mt-3">
											<div className="col-lg-12 text-end">
											<button onClick={() => setTab(0)} type="button" className="btn btn-tmAquaDgreen btnPrev me-2">
												<i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}
											</button>
											<button  onClick={goNext(1)} type="button" className="btn btn-tmAquaGreen btnNext">
												<i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}
											</button>
											</div>
										</div>
										</form>
									</div>
									)}

									{/* <!--TAB-03--> */}
									{tab === 2 && <div>
										<form autoComplete="off">
											<div className="row">
												<div className="col-lg-12">
													<div className="row">
														<div className="col-lg-6 col-md-6 mb-3">
															<label>Physician </label>
															{/*<select
																className="form-select"
																name="physicianId"
																value={data.physicianId || ''}
																onChange={handleChange}
															>
																<option value=''>-- Select Physician --</option>
																{physicianInfo.map(Physician => (
																	<option key={Physician.account} value={Physician.account}>
																		Dr. {Physician.first_name} {Physician.last_name}
																	</option>
																))}
															</select>*/}
															<Select
																value={
																	physicianInfo
																		.filter(option => option.account === data.physicianId)
																		.map(option => ({
																			value: option.account,
																			label: `Dr. ${option.first_name} ${option.last_name}`,
																		}))[0] || null
																}
																name="physicianId"
																onChange={(selectedOption) => 
																	handleChange({ target: { name: "physicianId", value: selectedOption?.value } })
																}
																options={
																	physicianInfo.map(Physician => ({
																		value: Physician.account,
																		label: `Dr. ${Physician.first_name} ${Physician.last_name}`,
																	}))
																}
																placeholder= {t('common.selectPhysician')}
																classNamePrefix="react-select"
															/>
														</div>
													</div>
													{data.physicianId && (
														<div className="secContent">
															<div className="table-responsive">
																<table className="table table-borderless theme-table">
																	<thead>
																		<tr>
																			<th scope="col">{t('profile.visitingDays')}</th>
																			<th scope="col">{t('profile.visitingHours')}</th>
																			<th scope="col">{t('profile.consultingDuration')}</th>
																		</tr>
																	</thead>
																	<tbody>
																		{filteredSchedules.length > 0 ? (
																			filteredSchedules.map((item, i) => (
																				<tr className="text-capitalize" key={i}>
																					<td className="prty-td">
																						<h5 className="table-title">
																							{item.days.length > 0 ? item.days.join(", ") : "--"}
																						</h5>
																					</td>
																					<td>
																						{item?.startTime ? convertTimeFormat(item?.startTime) : '--'}
																						{item?.startTime && item?.endTime && ' to '}
																						{item?.endTime && convertTimeFormat(item?.endTime)}
																					</td>
																					<td className="text-center">
																						{item.consultingDuration}
																					</td>
																				</tr>
																			))
																		) : (
																			<tr>
																				<td colSpan="2" className="text-center">
																					{constantVariables.common.noRecord}
																				</td>
																			</tr>
																		)}
																	</tbody>
																</table>
															</div>
														</div>
													)}
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">
												<div className="col-lg-12 text-end">
													<button onClick={() => setTab(1)} type="button" className="btn btn-tmAquaDgreen btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={handleSubmit} type="button" className="btn btn-tmAquaGreen" ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
												</div>
											</div>
										</form>
									</div>}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* /* <!-- End Page Content Section --> */}
		</main>
	);
};
export default EditParent;
